module.exports = __webpack_public_path__ + "static/media/homepage.cb4330f3.png";